import { fmtDate } from "@/lib/supervisorFormat";

/**
 * Read-only audit-log table for the Supervisor Panel. Rows come from
 * ``GET /api/supervisor/audit`` and are already sorted server-side by
 * newest first, so we render them verbatim.
 */
export default function AuditTab({ rows }) {
  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-900/50 overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-zinc-900 text-zinc-400 text-[11px] uppercase tracking-wider">
          <tr>
            <th className="px-4 py-3 text-left">Χρόνος</th>
            <th className="px-4 py-3 text-left">Actor</th>
            <th className="px-4 py-3 text-left">Action</th>
            <th className="px-4 py-3 text-left">Tenant</th>
            <th className="px-4 py-3 text-left">Λεπτομέρειες</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={5} className="px-4 py-12 text-center text-zinc-500">Καμία ενέργεια</td>
            </tr>
          )}
          {rows.map((r, i) => (
            <tr key={i} className="border-t border-zinc-800">
              <td className="px-4 py-2.5 text-xs text-zinc-400 font-mono whitespace-nowrap">{fmtDate(r.ts)}</td>
              <td className="px-4 py-2.5 text-xs text-zinc-300 font-bold">{r.actor}</td>
              <td className="px-4 py-2.5 text-xs font-mono text-amber-400">{r.action}</td>
              <td className="px-4 py-2.5 text-xs font-mono text-zinc-300">{r.tenant_code || "—"}</td>
              <td className="px-4 py-2.5 text-[11px] text-zinc-500 font-mono max-w-md truncate">
                {Object.keys(r.details || {}).length ? JSON.stringify(r.details) : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
